// test2597
(2597 && 0);
